import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 71px;
  flex-direction: row;
  align-items: center;
  padding: 23px 30px;
  justify-content: space-between;
  background-color: ${colors.green};
  z-index: 99;

  position: relative;
`

export const Logo = styled.img`
  width: 130px;
  height: 37.49px;
`
